<template lang="pug">
  f7-button(
    big
    fill
    @click="$emit('click', $event)"
  )
    p
      icon(name="check")
    label 送信する
</template>

<style lang="scss" scoped>
#framework7-root .button {
  background: none;
  border-radius: unset;

  p {
    margin: 0;
    padding: 0;
    line-height: 15px;
  }

  label {
    @extend %text-button-text;
    display: block;
    line-height: 12px;
    margin-top: 8px;
  }
}
</style>

<script>
export default {}
</script>
